const ML_ROUTING_STATUS_LABELS = {
  pass: "Pass",
  fail: "Fail",
  pending: "Pending",
};

/** API sends status as pass | fail | pending (string). */
export const formatMlRoutingStatus = (status) => {
  if (status === null || status === undefined || status === "") {
    return "-";
  }
  const normalized = String(status).trim().toLowerCase();
  if (ML_ROUTING_STATUS_LABELS[normalized]) {
    return ML_ROUTING_STATUS_LABELS[normalized];
  }
  return String(status);
};

/** Each row includes reasons: [{ flag, reason }, ...]. */
export const formatMlRoutingFlagsAndReasons = (reasons) => {
  if (!Array.isArray(reasons) || reasons.length === 0) {
    return {
      flags: "-",
      reasons: "-",
      flagList: [],
      reasonList: [],
    };
  }
  const flagList = reasons
    .map((entry) => entry?.flag)
    .filter((flag) => flag !== null && flag !== undefined && String(flag).trim() !== "")
    .map((flag) => String(flag).trim());
  const reasonList = reasons
    .map((entry) => entry?.reason)
    .filter((reason) => reason !== null && reason !== undefined && String(reason).trim() !== "")
    .map((reason) => String(reason).trim());
  return {
    flags: flagList.length ? flagList.join(", ") : "-",
    reasons: reasonList.length ? reasonList.join("; ") : "-",
    flagList,
    reasonList,
  };
};

export const mapMlRoutingApiRow = (item, index) => {
  const {
    flags, reasons, flagList, reasonList,
  } = formatMlRoutingFlagsAndReasons(item.reasons);
  const rowKey = item.tis_pk != null && item.tis_pk !== ""
    ? `tis-${item.tis_pk}`
    : `ml-routing-${item.workorder_id ?? "wo"}-${item.genista_id ?? "gb"}-${index}`;
  return {
    key: rowKey,
    customer_id: item.customer_id ?? "-",
    workorder_id: item.workorder_id ?? "-",
    genista_id: item.genista_id ?? "-",
    test: item.test ?? "-",
    status: formatMlRoutingStatus(item.status),
    flags,
    reasons,
    flagList,
    reasonList,
  };
};

/** qc_records_ml/ returns { message, result: [...] }. */
export const extractMlRoutingResultList = (apiResponse = {}) => {
  if (Array.isArray(apiResponse.result)) {
    return apiResponse.result;
  }
  if (Array.isArray(apiResponse.results)) {
    return apiResponse.results;
  }
  return [];
};
